import React from "react";
import TextInput from "./form-components/TextInput";
import { RadioGroup, RadioGroupItem } from "./form-components/RadioGroup";
import { cn } from "@/lib/utils";
import { useFormContext } from "./context/FormContext";
import ButtonSimple from "@/components/ui/button-simple";
import PhoneNumberInput from "./form-components/PhoneNumberInput";

const ContactInformationForm = () => {
  const { contactMethods, handleFormSubmit } = useFormContext();
  const { register, formState, watch, setValue } = contactMethods;

  const hasAllRequiredFields =
    watch("firstName") && watch("lastName") && watch("phone") && watch("profileType") !== "none";

  const isDisabled = !hasAllRequiredFields || Object.keys(formState.errors).length > 0;

  return (
    <form
      onSubmit={contactMethods.handleSubmit(data => handleFormSubmit(data, "contact"))}
      className="mt-8 space-y-4"
    >
      <TextInput
        label="First name"
        id="firstName"
        placeholder="Enter your first name"
        {...register("firstName")}
        error={formState.errors.firstName?.message}
      />

      <TextInput
        label="Last name"
        id="lastName"
        placeholder="Enter your last name"
        {...register("lastName")}
        error={formState.errors.lastName?.message}
      />

      <div className="space-y-2">
        <PhoneNumberInput
          label="Phone"
          value={watch("phone")}
          onChange={e => setValue("phone", e.target.value, { shouldValidate: true })}
          error={formState.touchedFields.phone ? formState.errors.phone?.message : undefined}
          placeholder="Enter your phone number"
        />
      </div>

      <div className="pt-4">
        <p className="mb-4 text-base font-medium text-system-disabled">
          Tell us a bit about yourself so we can tailor the experience to your needs
        </p>
        <RadioGroup
          {...register("profileType")}
          value={watch("profileType")}
          onChange={value => {
            setValue("profileType", value as "business" | "personal");
          }}
          error={formState.errors.profileType?.message}
        >
          <RadioGroupItem
            value="business"
            label="Business"
            description="For companies and organizations looking for scalable solutions."
          />
          <RadioGroupItem
            value="personal"
            label="Personal"
            description="For individual shoppers and enthusiasts seeking exclusive deals."
          />
        </RadioGroup>
      </div>

      <div className="w-full pt-4">
        <ButtonSimple
          type="submit"
          disabled={isDisabled}
          className={cn(
            "rounded-lg text-white transition-colors",
            !isDisabled
              ? "h-[42px] bg-system-primary"
              : "h-[42px] cursor-not-allowed bg-system-steel"
          )}
        >
          Next step
        </ButtonSimple>
      </div>
    </form>
  );
};

export default ContactInformationForm;
